import gql from "graphql-tag";

const getQuery = withEvu => gql`
  query Event($eventId: ID, $customerId: ID) {
    event(eventId: $eventId, customerId: $customerId) {
      id
      title
      deletedBy
      deletedAt
      description
      createdAt
      startedByUser {
        name
        username
      }
      finishedByUser {
        name
        username
      }
      billable
      visible
      isInternalTest
      localRec
      activeQod
      localRecInfo {
        userEmails {
          email
          locale
        }
        downloadWebUrl
      }
      authorizedRecording
      typeId
      graphicSetId
      customerId
      roomTemplateId
      contractId
      remoteProductionAvailable
      ${withEvu ? "evu" : ""}
      bertConfigId
      bertSimpleUrl
      emailReceipts
      emailLocale
      publicEventId
      subdeployment {
         id
          name
          description
          streamsourceIds
      }
      contract {
        id
        description
        hasRoomTemplates
        deployment {
          id
          codename
          sourceIds
        }
      }
      graphicSet {
        id
        name
        customerId
        layouts {
          assetId
        }
      }
      type {
        description
        isSportEvent
      }
      keywords
      startDate
      endDate
      eventStatus
      urlRemoteProduction
      urlRemoteLocution
      urlRemoteLocutionShort
      urlMixerBert
      elasticIp
      plenarySessionUrl
      roomTemplate {
        test
        codename
      }
      liveStreams {
        rtmpUrl
        key
        publishingUrl
        description
        componentName
        componentStatus
        type
      }
      sportEventData {
        scoreboardTemplateId
        scoreboardType
        altScoreboardTemplateName
        teamName1Abreviated
        teamName1
        teamLogo1
        teamLogoAsset1 {
          id
          codename
          format
          path
          description
          customerId
          hasGraphicsets
          sizePx {
            x
            y
          }
        }
        teamName2Abreviated
        teamName2
        teamLogo2
        teamLogoAsset2 {
          id
          codename
          format
          path
          description
          customerId
          hasGraphicsets
          sizePx {
            x
            y
          }
        }
      }
      matchPointConfig {
        ocurrencesSource
        ocurrencesSourceId
        ocurrencesVisible
        matchPointUrl
      }
      infoBert {
        componentAnyAbnormal
        elementAnyAbnormal
        iaDebugUrl
        iaScoreDebugUrl
        liveViewUrl
        remoteIngestions {
          id
          type
          url
          name
          larixUrl
        }
        recordingList {
          main
          url
          status
          description
        }
        componentStatus {
          name
          status
          autorun
          stereotype
          published {
            hls
            live
            youtube
            viewUrl
            debug
          }
        }
        vwsCamList {
          id
          name
          type
          src
        }
      }
    }
  }
`;

export default ({ eventId, customerId, withEvu, hasAdminPrivileges }) => ({
  query: getQuery(withEvu || hasAdminPrivileges),
  skip: !eventId || (!customerId && !hasAdminPrivileges),
  variables: { eventId, customerId },
  pollInterval: 5000,
});
